
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Question } from '@/lib/Question';
import store from '@/store';
import { AxiosResponse } from 'axios';
import { EntityChoice } from '@/lib/EntityChoice';
import { SuggestionDataRegistry } from '../lib/SuggestionDataRegistry';
import SuggestionChoices from '@/components/SuggestionChoices';
import { api } from '../Api';
import { helper } from '../Utils/Helper';

@Component(
    {
        components: {
            SuggestionChoices
        },
    },
)
export default class EntityQuestion extends Vue {
    @Prop() public question: Question;
    public search: string = '';
    public choicesOpen: boolean = false;
    public debounce: any = 0;
    public scrollDebounce: any = 0;
    public page = 1;
    public max = 0;
    public count = 0;
    public canScroll = true;
    public total = 0;

    public choose(choice: any) {
        setTimeout(() => {
            this.$emit('chosen');
        }, 500);
        this.updateAnswer(choice);
    }

    public chooseIcon(id: any, label: string) {
        this.choose(new EntityChoice(parseInt(id + ''), label));
    }

    public isSelected(id) {
        const currentResponse = this.question.currentResponse!;
        return currentResponse.valueId + '' == id + '';
    }


    public openChoices() {
        this.choicesOpen = true;
    }

    public searching(question: Question) {
        this.search = question.currentResponse.value;
        this.updateField(question);
    }


    public closeChoices(immediately: boolean) {
        if (immediately) {
            this.choicesOpen = false;
        } else {
            setTimeout(() => {
                this.choicesOpen = false;
            }, 250);
        }

    }

    public scroll(event: any) {
        clearTimeout(this.scrollDebounce);
        this.scrollDebounce = setTimeout(() => {
            const target = event.target;
            const toScroll = target.scrollHeight - (target.scrollTop + target.clientHeight);
            if (toScroll < 15) {
                this.updateField(this.question, true);
            }
        }, 250);
    }



    public toggleChoices() {
        this.choicesOpen = !this.choicesOpen;
    }

    public clearResponse() {
        const currentResponse = this.question.currentResponse!;
        currentResponse.value = '';
        currentResponse.valueId = 0;
        this.question.validate();
        this.openChoices();
        this.updateField(this.question);
        this.question.changedEvent.emit('');

    }

    public blur(event) {
        // console.log(this.question)
        // console.log(event)
        if (!this.question.currentResponse.valueId) {
            this.createChoice(event.target.value)
        }
        this.question.changedEvent.emit('');
        this.closeChoices(false);
    }

    async createChoice(choice: string) {
        // console.log(choice)
        if (!helper.empty(choice) && this.question.responseType.className === "CarModel") {
            if (this.question.filteredByQuestionId) {
                const filteredBy = store.getters.getQuestion(this.question.filteredByQuestionId);
                // console.log(filteredBy)
                if (filteredBy) {
                    const res = await api.createChoice('CarModel', choice,filteredBy.currentResponse.valueId)
                    // console.log(res)
                    const ec = new EntityChoice(res.data.choice.id, res.data.choice.label)
                    // console.log(ec)
                    this.updateAnswer(ec)

                }
            }
        }
    }

    isGreyed() {
        if (this.filteredBy) {
            const filterBy = this.filteredBy;
            if (filterBy && filterBy.responseType.template === 'hidden') {
                return false;
            }
            return this.filteredBy.currentResponseIsEmpty();
        }
        return false;
    }

    get filteredBy() {
        return store.getters.getQuestion(this.question.filteredByQuestionId);
    }

    public mounted() {
        this.updateField(this.question);
        if (this.question.filteredByQuestionId) {
            const filteredBy = store.getters.getQuestion(this.question.filteredByQuestionId);
            if (filteredBy) {
                filteredBy.changedEvent.on(() => {
                    this.updateField(this.question, false);
                });
            }
        }
    }

    public updateField(question: Question, paginate = false) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(
            () => {
                if (paginate) {
                    this.page++;
                } else {
                    this.page = 1;
                }
                if (this.isGreyed()) {
                    const currentResponse = this.question.currentResponse!;
                    currentResponse.value = '';
                    currentResponse.valueId = 0;
                }
                // console.log(this.search);
                store.dispatch('filterQuestion', {
                    question,
                    page: this.page,
                    search: this.search
                }).then((response: AxiosResponse) => {
                    if (response.status !== 200) {
                        store.commit('throwError', response.data.data);
                    }
                    const data = response.data.data;
                    const objects = data.objects;
                    this.max = data.max;
                    this.total = data.count;
                    this.count = objects.length;

                    if(this.count === 0){
                        this.createChoice(this.search)
                    }

                    const entityChoices = objects.map((result: any) => new EntityChoice(result.id, result.label));

                    if (paginate) {
                        this.question.entityChoices.push(...entityChoices);
                    } else {
                        this.question.entityChoices = entityChoices;
                    }
                    // console.log(this.question.entityChoices);
                    // console.log(this.question.required, this.question.currentResponseIsEmpty(), !this.choicesOpen, this.question.entityChoices.length);
                    if (this.question.required && this.question.currentResponseIsEmpty() && !this.choicesOpen && this.question.entityChoices.length) {
                        if (this.filteredBy && this.filteredBy.responseType.template === 'hidden') {
                            // console.log(this.question.entityChoices[0]);
                            this.updateAnswer(this.question.entityChoices[0]);
                        }
                        // if(this.question.defaultValue){
                        //     console.log(this.question.defaultValue);
                        //     const defaultOption = this.question.entityChoices.find((choice: EntityChoice) => {
                        //         return choice.id + '' === this.question.defaultValue;
                        //     });
                        //     if (defaultOption) {
                        //         console.log(defaultOption);
                        //         this.updateAnswer(defaultOption);
                        //     }
                        // }
                    }

                });
            },
            500
        );

    }

    public updateAnswer(choice: EntityChoice) {
        const currentResponse = this.question.currentResponse!;
        currentResponse.value = choice.value;
        currentResponse.valueId = choice.id;
        const event = document.createEvent('HTMLEvents');
        this.closeChoices(true);
        event.initEvent('blur', true, true);
        this.$refs.input.dispatchEvent(event);
        this.question.validate();
    }
}
